/**
 * BrandContextHint
 *
 * Kleiner, unaufdringlicher Hinweis, der erscheint wenn KI-Ergebnisse
 * auf Basis des gespeicherten Markenprofils generiert wurden.
 *
 * Verwendung:
 *   <BrandContextHint show={response.brand_context_used} />
 *   <BrandContextHint show={true} text="Diese Strategie..." />
 *
 * Props:
 *   show  – Boolean: Hinweis nur anzeigen wenn true
 *   text  – Optionaler eigener Hinweistext (Deutsch)
 */

const BrandContextHint = ({ show, text }) => {
  if (!show) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-emerald-50 border border-emerald-200 rounded-lg text-xs text-emerald-700">
      <span>✨</span>
      <span>
        {text || "Diese Vorschläge basieren auf deinem gespeicherten Markenprofil."}
      </span>
    </div>
  );
};

export default BrandContextHint;
